import MuiTableRow from '@material-ui/core/TableRow';
import styled from 'styled-components';
import {
  ClickableTextMixin,
  HighlightStyle,
  STICKY_OFFSET
} from '../common-styles';
import MuiTableCell from '@material-ui/core/TableCell';
import { getColor } from 'common/constants/_colors';
import { SIZES } from 'common/constants/sizes';

export const StyledColorIndicator = styled.div`
  background-color: ${props => getColor(props.color)};
  width: 1rem;
  height: 1rem;
  border-radius: 0.1rem;
`;

export const StyledExpandedSortByTooltip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  & span.col-name {
    font-weight: bold;
  }
  & > svg {
    margin-right: 0.5rem;
  }
`;

export const StyledTableCell = styled(MuiTableCell)`
  &.isSorted {
    box-shadow: -5px 0px 10px 0px ${getColor('zircon')},
      5px 0px 10px 0px ${getColor('zircon')};
    background: ${getColor('white')};
  }
  &.isFirstCol.isRowsExpandable {
    ${({ level }) => level && `padding-left: ${level * 3 + 1.2}rem`};
    & > span {
      display: flex;
      align-items: center;
      position: relative;
    }

    & .row-expand-toggle {
      position: absolute;
      font-size: 2rem;
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }

    & .name {
      margin-left: 2rem;
    }
  }
`;

export const StyledTableHeaderCell = styled(StyledTableCell)`
  box-sizing: content-box;
  position: relative;
  & .col-header {
    color: ${getColor('gray')};
  }

  &.isSorted {
  }
  &.isExpanded {
    background-color: ${getColor('zircon')};
  }
  &.isExpanded.isParent:not(.isSorted) {
    & .col-header {
      font-weight: 500;
      color: ${getColor('indigo')};
    }
  }
  &.isLastExpendedChild {
    & .MuiTableSortLabel-icon {
      margin-right: 1.5rem;
    }
  }

  & svg#HelpIcon {
    margin-left: 1rem;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const StyledTableRow = styled(MuiTableRow)`
  ${({ onClick, cursor = 'pointer' }) =>
    onClick && `&:hover{cursor: ${cursor}}`}

  ${({ backgroundcolor }) =>
    backgroundcolor ? `background-color: ${backgroundcolor}` : ''};

  ${({ highlight }) => highlight && `${HighlightStyle}`};

  ${({ grayedout }) =>
    grayedout
      ? `
                background: repeating-linear-gradient(-45deg, ${getColor(
                  'catskillWhite'
                )},
                    ${getColor('catskillWhite')} 1px, ${getColor(
          'white'
        )} 2px, ${getColor('white')} 10px);
                filter: grayscale(100%);`
      : ''};

  ${({ transition }) =>
    transition &&
    `
                &.${transition.className}-enter {
                opacity: 0;
                }
                &.${transition.className}-enter-active {
                    opacity: 1;
                    transition: opacity ${
                      transition.timeout.enter - 100
                    }ms ease-in;
                }
                &.${transition.className}-exit {
                    opacity: 1;
                }
                &.${transition.className}-exit-active {
                    opacity: 0;
                    transition: opacity ${
                      transition.timeout.exit - 100
                    }ms ease-in;
                }`}
`;

export const StyledCell = styled.div`
  font-size: ${SIZES.medium};
  display: flex;
  align-items: center;
  height: 100%;
  ${ClickableTextMixin};
`;

export const StyledTableHeaderRow = styled(MuiTableRow)`
  height: 3rem;

  &.withStickyHeader {
    position: sticky;
    z-index: 49;
    top: -${STICKY_OFFSET}rem;
    background-color: white;
  }
`;
